import React from 'react';

import './App.css';
import "/node_modules/primereact/resources/themes/lara-light-cyan/theme.css";
import "/node_modules/primeflex/primeflex.css";
import '/node_modules/primeicons/primeicons.css';

import { AuthProvider } from './AuthContext';
import MainApp from "./components/MainApp";

function App() {

    return (
        <AuthProvider>
            <MainApp />
        </AuthProvider>
    );
}

export default App;